import dayjs, { Dayjs } from 'dayjs';

export const MONTHS_PT_BR = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
];

export function getMonthAbbreviation(date: Date): string {
  return MONTHS_PT_BR[date.getMonth()];
}

export function toLocalDateTimeString(
  value: Dayjs | Date | string | null | undefined,
): string | null {
  if (!value) return null;
  const d = dayjs(value);
  if (!d.isValid()) return null;
  return d.format('YYYY-MM-DDTHH:mm:ss');
}

export function parseISODate(value: string | null | undefined): Date | null {
  if (!value) return null;
  const d = dayjs(value);
  if (!d.isValid()) return null;
  return d.toDate();
}

export function formatISODate(value: Date | string | null | undefined): string {
  const d = dayjs(value);
  if (!d.isValid()) return '';
  return d.format('YYYY-MM-DD');
}

export function formatISODateTime(value: Date | string | null | undefined): string {
  const d = dayjs(value);
  if (!d.isValid()) return '';
  return d.toISOString();
}

export function parseDataOnlyLocal(value: string | null | undefined): Date | null {
  if (!value) return null;
  // Tolera tanto data-only ("2026-08-05") quanto um prefixo ISO datetime
  // ("2026-03-01T12:00:00Z") — em ambos os casos só o componente de data
  // (ano-mes-dia) importa; o restante da string, se houver, é descartado.
  const match = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (!match) return null;
  const [, anoStr, mesStr, diaStr] = match;
  const year = Number(anoStr);
  const month = Number(mesStr);
  const day = Number(diaStr);
  const data = new Date(year, month - 1, day);
  if (Number.isNaN(data.getTime())) return null;
  return data;
}

export function formatDataTorneioBR(value: string | null | undefined): string {
  const data = parseDataOnlyLocal(value);
  if (!data) return '';
  return data.toLocaleDateString('pt-BR');
}

export function formatPeriodoTorneioBR(
  dataInicio: string | null | undefined,
  dataFim: string | null | undefined,
): string {
  const inicio = formatDataTorneioBR(dataInicio);
  const fim = formatDataTorneioBR(dataFim);
  if (inicio && fim) return `${inicio} a ${fim}`;
  if (inicio) return inicio;
  return '';
}
